module.exports = __webpack_public_path__ + "static/media/bg_frame.915a3674.png";